(ns ycweb.components.datatables.wrapper.exports
  "Export functionality (CSV, Excel, PDF) using DataTables Buttons extension")

;; DataTables Buttons extension for exports
;; Docs: https://datatables.net/extensions/buttons/

(defn export-config
  "Generate DataTables Buttons configuration for exports.

   Options:
   - :csv? - Enable CSV export (default: false)
   - :excel? - Enable Excel export (default: false)
   - :pdf? - Enable PDF export (default: false)
   - :filename - Base filename for exports (default: 'export')
   - :title - Title for PDF exports
   - :columns - Column indices to export (default: all visible columns)

   Example:
   {:csv? true
    :excel? true
    :filename \"integration-links\"
    :title \"Integration Links Report\"}"
  [{:keys [csv? excel? pdf? filename title columns] :as export-opts}]
  (when (or csv? excel? pdf?)
    (let [base-filename (or filename "export")
          export-title (or title "Data Export")
          buttons (cond-> []
                    csv?
                    (conj {:extend "csv"
                           :text "Export CSV"
                           :filename base-filename
                           :exportOptions
                           {:columns (or columns ":visible")}})

                    excel?
                    (conj {:extend "excel"
                           :text "Export Excel"
                           :filename base-filename
                           :title export-title
                           :exportOptions
                           {:columns (or columns ":visible")}})

                    pdf?
                    (conj {:extend "pdf"
                           :text "Export PDF"
                           :filename base-filename
                           :title export-title
                           :orientation "landscape"
                           :pageSize "A4"
                           :exportOptions
                           {:columns (or columns ":visible")}}))]
      {:dom "Bfrtip"  ; B = Buttons, f = filter, r = processing, t = table, i = info, p = pagination
       :buttons buttons})))

(defn add-export-buttons
  "Add export functionality to DataTables configuration.

   Usage:
   (add-export-buttons dt-options
     {:csv? true
      :excel? true
      :filename \"my-report\"})"
  [dt-options export-opts]
  (if-let [export-config (export-config export-opts)]
    (merge dt-options export-config)
    dt-options))

;; Notes on DataTables Buttons extension:
;;
;; 1. CSV Export:
;;    - Client-side only (uses browser's built-in CSV generation)
;;    - No external dependencies required
;;    - Respects column visibility and export options
;;
;; 2. Excel Export:
;;    - Requires jszip library (already in package.json)
;;    - Generates .xlsx files
;;    - Supports basic styling and formatting
;;    - Can export large datasets (10k+ rows)
;;
;; 3. PDF Export:
;;    - Requires pdfmake library (already in package.json)
;;    - Generates .pdf files with tables
;;    - Supports custom page sizes and orientations
;;    - Best for smaller datasets (performance considerations)
;;
;; 4. Integration with server-side processing:
;;    - Exports only visible/loaded data by default
;;    - For full dataset export, need custom server endpoint
;;    - Can use :action button with custom export API call
;;
;; 5. Button positioning:
;;    - Uses DataTables dom option for layout
;;    - "Bfrtip" = Buttons + filter + processing + table + info + pagination
;;    - Can customize positioning with CSS or custom dom string
;;
;; 6. Customization options:
;;    - :columns - Specify which columns to export (e.g., ":visible", [0,1,2])
;;    - :filename - Base filename (datetime auto-appended)
;;    - :title - Document title (PDF only)
;;    - :orientation - "portrait" or "landscape" (PDF only)
;;    - :pageSize - "A4", "LETTER", etc. (PDF only)
;;    - :exportOptions - Advanced filtering and formatting
;;
;; Example advanced configuration:
;;
;; {:csv? true
;;  :excel? true
;;  :pdf? true
;;  :filename \"sales-report\"
;;  :title \"Monthly Sales Report\"
;;  :columns [1, 2, 3, 4]  ; Export columns 1-4 only
;;  :exportOptions
;;  {:modifier
;;   {:search \"applied\"  ; Export only filtered data
;;    :order \"applied\"   ; Respect current sort order
;;    :page \"all\"}       ; Export all pages (not just current)
;;   :format
;;   {:header (fn [data idx]
;;              ;; Custom header formatting
;;              (str data))
;;    :body (fn [data row col]
;;            ;; Custom cell formatting
;;            (str data))}}}
